import { propertiesPersistedPromise } from 'fdsr-migration-layer';
import { fromHttpPromise } from 'pulse/adapters';
export const defaultPropertyGroupsResolver = fromHttpPromise('propertyGroupsResolver', (httpClient, {
  objectTypeId
}) => propertiesPersistedPromise.makeFetchWithOpts({
  refresh: true
})({
  httpClient: httpClient,
  frameworkTypeIdentifier: objectTypeId,
  query: {
    // Always pass `true`. We can derive the result of passing `false` from the result of passing `true`, but not the inverse.
    showHighlySensitiveProperties: true
  }
}));